
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CalendarIcon, Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { format, differenceInDays } from 'date-fns';
import { useNavigate } from 'react-router-dom';

interface PeriodHistoryCardProps {
  isLoading: boolean;
  periodHistory: any[];
}

const PeriodHistoryCard: React.FC<PeriodHistoryCardProps> = ({
  isLoading,
  periodHistory
}) => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <CalendarIcon className="mr-2 h-5 w-5 text-hormony-coral" />
          Period History
        </CardTitle>
        <CardDescription>
          Your recent period data
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="h-40 flex items-center justify-center">
            <div className="animate-spin h-8 w-8 border-4 border-hormony-coral border-t-transparent rounded-full"></div>
          </div>
        ) : periodHistory.length > 0 ? (
          <div className="space-y-2 max-h-60 overflow-y-auto">
            {periodHistory.map((period) => (
              <div key={period.id} className="flex justify-between items-center p-2 hover:bg-muted/50 rounded-md">
                <div>
                  <p className="font-medium">
                    {format(new Date(period.period_start_date), 'MMMM d, yyyy')}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    Duration: {period.period_length || 
                      (period.period_end_date ? 
                        differenceInDays(new Date(period.period_end_date), new Date(period.period_start_date)) + 1 : 
                        'Unknown')} days
                  </p>
                </div>
                <span className="text-xs px-2 py-1 rounded-full bg-hormony-coral/20 text-hormony-coral">
                  {period.data_source === 'import' ? 'Imported' : 
                   period.data_source === 'prediction' ? 'Predicted' : 'Manual'}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <p className="text-muted-foreground mb-3">No period history found</p>
            <div className="flex flex-col gap-2">
              <Button 
                variant="default" 
                onClick={() => navigate('/cycle-tracking')}
              >
                <Calendar className="mr-2 h-4 w-4" />
                Track Your Period
              </Button>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PeriodHistoryCard;
